import React from "react";
import MembershipPackageTable from "./MembershipPackageTable";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../../store/adminData/adminData";
import { fetchPackages } from "../../../../../services/api/packages";
import useMembers from "../../Members/useMembers";
import "./Packages.css";
import DescriptionText from "../../../../../CommonComponents/DescriptionText";

const PackagesTable = ({ addPackage }) => {
  const groupData = useAdminDataStore(selectCurrentGroupData);

  const { membersList, membersLoading } = useMembers();

  const packageAutoRenewCountMap = membersList?.reduce((acc, obj) => {
    const { package: pkgId, subscriptionDetail } = obj;

    if (subscriptionDetail?.status === "active") {
      acc[pkgId] = (acc[pkgId] || 0) + 1;
    }

    return acc;
  }, {});

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        paddingTop: "0",
      }}
      className="packages-table-container"
    >
      <div>
        <DescriptionText showBackground>
          <p className="pb-2">
            Sell membership packages, merchandise and collect donations. Stripe
            account required. Add a package and complete the &apos;Setup&apos;
            section. Once published, share your{" "}
            <a
              target="_blank"
              href={`https://group.chant.fan/${groupData?.groupName?.trim()?.toLowerCase()?.replace(/\s+/g, "")}/join`}
              rel="noreferrer"
            >
              web registration page
            </a>{" "}
            with members.
          </p>
          <p className="pb-2">
            Members who purchase a package are automatically pre-registered for
            Chant and required to renew each season to maintain access. Consider
            enabling auto-renewal (subscriptions) for member packages and
            donations.
          </p>

          <p>
            If package includes merchandise (scarf, shirt, etc) first add the
            item to the Store (in Store/Merchandise) then link it to the member
            package (in add/edit package) to streamline fulfillment. Orders
            appear in the &apos;Store: Orders&apos; report.
          </p>
        </DescriptionText>
        <MembershipPackageTable
          packageAutoRenewCountMap={packageAutoRenewCountMap}
          membersLoading={membersLoading}
          addPackage={addPackage}
        />
      </div>
    </div>
  );
};

export default PackagesTable;
